import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Admin.css';

function Admin({ user }) {
  const [pendingReviews, setPendingReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingReviews();
  }, []);

  const fetchPendingReviews = async () => {
    try {
      const response = await axios.get('/api/admin/reviews/pending');
      setPendingReviews(response.data);
    } catch (error) {
      console.error('Error fetching pending reviews:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (reviewId) => {
    try {
      await axios.put(`/api/admin/reviews/${reviewId}/approve`);
      fetchPendingReviews();
    } catch (error) {
      console.error('Error approving review:', error);
      alert('Ошибка при одобрении отзыва');
    }
  };

  const handleReject = async (reviewId) => {
    try {
      await axios.put(`/api/admin/reviews/${reviewId}/reject`);
      fetchPendingReviews();
    } catch (error) {
      console.error('Error rejecting review:', error);
      alert('Ошибка при отклонении отзыва');
    }
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="admin">
      <section className="section">
        <div className="container">
          <h1 className="section-title">Панель модерации</h1>
          <p className="section-subtitle">
            Отзывы, ожидающие модерации: {pendingReviews.length}
          </p>

          <div className="admin-reviews">
            {pendingReviews.length === 0 ? (
              <p className="no-reviews">Нет отзывов на модерации</p>
            ) : (
              pendingReviews.map((review) => (
                <div key={review._id} className="admin-review-card">
                  <div className="review-header">
                    <img 
                      src={review.avatar || '/default-avatar.png'} 
                      alt={review.username}
                      className="review-avatar"
                    />
                    <div className="review-user-info">
                      <div className="review-username">{review.username}</div>
                      <div className="review-server">{review.server}</div>
                    </div>
                    <div className="review-rating">
                      {'★'.repeat(review.rating)}
                      {'☆'.repeat(5 - review.rating)}
                    </div>
                  </div>
                  <div className="review-text">{review.text}</div>
                  <div className="review-date">
                    {new Date(review.createdAt).toLocaleDateString('ru-RU')}
                  </div>
                  <div className="admin-actions">
                    <button 
                      onClick={() => handleApprove(review._id)}
                      className="btn btn-approve"
                    >
                      Одобрить
                    </button>
                    <button 
                      onClick={() => handleReject(review._id)}
                      className="btn btn-reject"
                    >
                      Отклонить
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Admin;

